export const CONTRACT_TYPES = {
    ACCOUNT: "account",
    CARDS: "cards",
    MORTGAGES: "mortgages",
    LOANS: "loans",
    WALLET: "wallet",
    DEPOSITS: "deposits",
    PREGRANTEDCREDIT: "pregrantedcredit",
};
